import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicDrawerComponent from "./BasicDrawerComponent";
import MiniDrawerComponent from "./MiniDrawerComponent";
import DrawerWithHeaderComponent from "./DrawerWithHeaderComponent";
import RightDrawerWithHeaderComponent from "./RightDrawerWithHeaderComponent";

const DrawerPage = () => {
  return (
    <>
      <Paper elevation={0}>
        <PageTitleBox
          title={"Drawer"}
          description={
            'The navigation drawers (or "sidebars") provide ergonomic access to destinations in a site or app functionality such as switching accounts.\n'
          }
        />
        <Divider light />
        <BasicDrawerComponent />
        <DrawerWithHeaderComponent />
        <RightDrawerWithHeaderComponent />
        <MiniDrawerComponent />
      </Paper>
    </>
  );
};

export default DrawerPage;
